<template>
  <div>
    <app-button
      type="outlined"
      variant="neutral"
      class="my-1 btn-allow-wrap"
      size="small"
      :x-padding="1"
      @click="openDialog = true"
    >
      <app-material-icon
        name="check_circle"
        color="icon-success"
      />
      {{ $t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.validation.validateDocument') }}
    </app-button>
    <app-modal v-model="openDialog"
               size="md"
               :ok-disabled="postValidationPending"
               :ok-loading="postValidationPending"
               :cancel-disabled="postValidationPending"
               @cancel="resetAndClose"
               @ok="preparePostValidation"
    >
      <template #title>{{ $t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.dialog.title') }}</template>
      <template #body>
        <v-row>
          <v-col>
            <Alert>
              {{ $t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.alertText') }}
            </Alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="8" offset-lg="2">
            <AppFileInput
              v-model="file"
              class="validation-file-input"
              color="primary"
              density="comfortable"
              prepend-icon="attach_file"
              clear-icon="close"
              :label="$t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.fileInputLabel')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            {{ $t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.dialog.text') }}
          </v-col>
        </v-row>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import Alert from '@/common/alerts/Alert.vue'
import AppFileInput from '@/common/AppFileInput.vue'
import { toast } from '@/common/utils/toast'
import { POST_VALIDATION, REFRESH_STEP } from '@/store/modules/signing-checklist/action_types'
import { SET_SELECTED_STEPS } from '@/store/modules/signing-checklist/mutation_types'

export default {
  name: 'SigningChecklistTableItemValidateDialog',
  components: { AppFileInput, Alert },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    envelopeId: {
      type: Number,
      required: true,
    },
    validationId: {
      type: Number,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      openDialog: false,
      file: null,
    }
  },
  computed: {
    ...mapState('signingChecklist', ['postValidationPending']),
  },
  methods: {
    ...mapActions('signingChecklist', [POST_VALIDATION, REFRESH_STEP]),
    ...mapMutations('signingChecklist', [SET_SELECTED_STEPS]),
    async preparePostValidation () {
      try {
        let formData = null
        if (this.file) {
          formData = new FormData()
          formData.append('file', this.file, this.file.name)
        }
        await this.POST_VALIDATION({
          mnemo: this.mnemo,
          envelopeId: this.envelopeId,
          validationId: this.validationId,
          data: formData || null,
        })
        this.openDialog = false
        this.SET_SELECTED_STEPS([])
        toast.success(this.$t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.message.success'))
        await this.REFRESH_STEP({
          mnemo: this.mnemo,
          stepId: this.stepId,
          parent: this.parent,
        })
      } catch (e) {
        console.error(e)
        toast.error(this.$t('project.signing-checklist.list.SigningChecklistTableItemValidateDialog.message.error'))
      }
    },
    resetAndClose () {
      this.file = null
      this.openDialog = false
    },
  },
}
</script>

<style scoped lang="scss">
.validation-file-input {
  :deep(.v-input__prepend > .v-icon),
  :deep(.v-input__control > .v-field > .v-field__clearable > .v-icon){
    color: rgb(var(--v-theme-grey-600));
    font-size: 18px;
  }
}
</style>
